import { property } from "lit/decorators.js";
import ComponentBase from "./component-base";
import { html } from "lit";

class Stepper extends ComponentBase {
  static get tagName() {
    return "ncx-stepper";
  }

  @property()
  steps: [];
  @property()
  currentStep: number;

  protected render(): unknown {
    return this.steps[this.currentStep];
  }
}
Stepper.Register();
export default Stepper;
